"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowUp = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ArrowUp = function ArrowUp(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7184 10.8205L12.7087 4.8108C12.5206 4.62118 12.2646 4.51453 11.9975 4.51453C11.7305 4.51453 11.4745 4.62118 11.2864 4.8108L5.27668 10.8205C4.88669 11.2133 4.88894 11.8478 5.28169 12.2378C5.67445 12.6278 6.30899 12.6255 6.69898 12.2328L10.9959 7.91581L10.9959 18.5129C10.9959 19.0661 11.4444 19.5145 11.9975 19.5145C12.5507 19.5145 12.9991 19.0661 12.9991 18.5129L12.9991 7.91581L17.2961 12.2328C17.4835 12.4239 17.7395 12.5322 18.0072 12.5333C18.2735 12.5348 18.5293 12.4303 18.7184 12.2428C18.908 12.0547 19.0146 11.7987 19.0146 11.5316C19.0146 11.2646 18.908 11.0086 18.7184 10.8205Z"
  }));
};

exports.ArrowUp = ArrowUp;